/** @format */

import * as _ from "lodash";
import { create, all } from "mathjs";
var config = {};
var math = create(all, config);
import { AssetAllocation } from "./portfolios";
import { InvestmentAccount, InvestmentAccountType } from "./accounts";
import {
  getIncome,
  GetIncomeCashFlowRequest,
  GetIncomeCashFlowResponse,
} from "./income";
var ProjectionRequest = /** @class */ (function() {
  function ProjectionRequest(init) {
    this.accounts = [];
    this.filterAccountId = 0;
    this.currentAge = 65;
    this.incomeRequest = new GetIncomeCashFlowRequest();
    this.incomeToLastUntilAge = 93;
    // withdrawal strategy
    this.withdrawalStrategy = 0;
    Object.assign(this, init);
  }
  return ProjectionRequest;
})();
export { ProjectionRequest };
export var WithdrawalStrategy;
(function(WithdrawalStrategy) {
  WithdrawalStrategy[(WithdrawalStrategy["Even"] = 0)] = "Even";
  WithdrawalStrategy[(WithdrawalStrategy["Custom"] = 1)] = "Custom";
})(WithdrawalStrategy || (WithdrawalStrategy = {}));
var ProjectionResponse = /** @class */ (function() {
  function ProjectionResponse(init) {
    this.projections = [];
    this.accountProjections = [];
    this.incomeTargetCfs = new GetIncomeCashFlowResponse();
    Object.assign(this, init);
  }
  return ProjectionResponse;
})();
export { ProjectionResponse };
var ReturnView = /** @class */ (function() {
  function ReturnView(init) {
    this.expectedReturn = 0;
    this.expectedReturnOptimistic = 0;
    this.expectedReturnOptimistic2 = 0;
    this.expectedReturnOptimistic3 = 0;
    this.expectedReturnPessimistic = 0;
    this.expectedReturnPessimistic2 = 0;
    this.expectedReturnPessimistic3 = 0;
    Object.assign(this, init);
  }
  return ReturnView;
})();
export { ReturnView };
var CalculateStatsRequest = /** @class */ (function() {
  function CalculateStatsRequest(init) {
    this.expectedInflation = 0.055;
    this.assetAllocation = new AssetAllocation();
    Object.assign(this, init);
  }
  return CalculateStatsRequest;
})();
export { CalculateStatsRequest };
var CalculateStatsResponse = /** @class */ (function() {
  function CalculateStatsResponse(init) {
    this.expectedReturn = 0;
    this.standardDeviation = 0;
    Object.assign(this, init);
  }
  return CalculateStatsResponse;
})();
export { CalculateStatsResponse };
// functions
export function calculateProjection(request) {
  console.log("projections.ts -> request", request);
  var projections = [];
  var accountBalances = [];
  var incomeTargetCfs = getIncome(request.incomeRequest); //.incomes;
  console.log("incomeTargetCfs", incomeTargetCfs);
  // add year 0 balances for each account
  var tempBalances = [];
  for (var i = 0; i < request.accounts.length; i++) {
    var account = request.accounts[i];
    tempBalances.push(
      new AccountBalanceView({
        year: request.currentAge,
        accountId: account.accountId,
        account: account,
        balance: account.accountMarketValue,
        balanceOptimisticValue: account.accountMarketValue,
        balanceOptimisticValue2: account.accountMarketValue,
        balanceOptimisticValue3: account.accountMarketValue,
        balancePessimisticValue: account.accountMarketValue,
        balancePessimisticValue2: account.accountMarketValue,
        balancePessimisticValue3: account.accountMarketValue,
        assetAllocation: getAccountPortfolioAssetAllocation(account),
        tic: getAccountTic(account),
      })
    );
  }
  // cycle through year  1 -> year to retirement for each account
  var tempYear = request.currentAge;
  // let tempBalances = accountBalances;
  while (tempYear <= request.incomeToLastUntilAge) {
    var yr = tempYear;
    var newBalances = applyInvestmentReturns(tempBalances, yr);
    // apply incomes
    var filteredTargetIncome = _.filter(incomeTargetCfs.incomes, {
      year: yr,
    });
    // apply income
    if (filteredTargetIncome.length > 0) {
      newBalances = applyIncomeToAccounts(
        filteredTargetIncome[0].income,
        newBalances,
        request.withdrawalStrategy
      );
    }
    // apply tic
    newBalances = applyTicToAccounts(newBalances);
    // apply aa
    newBalances = applyAaToAccounts(newBalances);
    // push accout balances
    for (var b = 0; b < newBalances.length; b++) {
      accountBalances.push(newBalances[b]);
    }
    console.log("new balances for " + tempYear, newBalances);
    tempBalances = newBalances;
    tempYear++;
  }
  // display filteracccounts in projections:
  tempYear = request.currentAge;
  while (tempYear <= request.incomeToLastUntilAge) {
    var yr = tempYear;
    var filteracccounts = _.filter(accountBalances, { year: yr });
    if (request.filterAccountId != 0) {
      filteracccounts = _.filter(filteracccounts, {
        accountId: request.filterAccountId,
      });
    }
    var total = Number(_.sumBy(filteracccounts, "balance"));
    var balanceOptimisticValue = Number(
      _.sumBy(filteracccounts, "balanceOptimisticValue")
    );
    var balanceOptimisticValue2 = Number(
      _.sumBy(filteracccounts, "balanceOptimisticValue2")
    );
    var balanceOptimisticValue3 = Number(
      _.sumBy(filteracccounts, "balanceOptimisticValue3")
    );
    var balancePessimisticValue = Number(
      _.sumBy(filteracccounts, "balancePessimisticValue")
    );
    var balancePessimisticValue2 = Number(
      _.sumBy(filteracccounts, "balancePessimisticValue2")
    );
    var balancePessimisticValue3 = Number(
      _.sumBy(filteracccounts, "balancePessimisticValue3")
    );
    var totalIncome = Number(_.sumBy(filteracccounts, "income"));
    var totalTic = 0;
    // calculate total tic & aa
    if (total != 0) {
      for (i = 0; i < filteracccounts.length; i++) {
        var ai = filteracccounts[i];
        totalTic += (ai.tic * ai.balance) / total;
      }
    }
    projections.push(
      new ProjectedView({
        year: yr,
        balance: total,
        balanceOptimisticValue: balanceOptimisticValue,
        balanceOptimisticValue2: balanceOptimisticValue2,
        balanceOptimisticValue3: balanceOptimisticValue3,
        balancePessimisticValue: balancePessimisticValue,
        balancePessimisticValue2: balancePessimisticValue2,
        balancePessimisticValue3: balancePessimisticValue3,
        income: totalIncome,
        incomePercent: totalIncome / total,
        tic: totalTic,
        assetAllocation: getAaForAccounts(filteracccounts),
      })
    );
    tempYear = yr + 1;
  }
  return new ProjectionResponse({
    projections: projections,
    accountProjections: accountBalances,
    incomeTargetCfs: incomeTargetCfs,
  });
}
export function applyIncomeToAccounts(
  income,
  accountBalancesPreIncome,
  withdrawalStrategy
) {
  var accountBalancesPostIncome = accountBalancesPreIncome; //accountBalancesPreIncome;
  // firstly apply target incomes
  var accountIncomes = [];
  // apply constraints - min, max
  for (var i = 0; i < accountBalancesPreIncome.length; i++) {
    var existingAc = accountBalancesPreIncome[i];
    var ac = new AccountIncomeContraints();
    _.assign(ac, accountBalancesPreIncome[i]); // assign all variables
    // apply min max constraints
    switch (existingAc.account.accountType) {
      case InvestmentAccountType.LivingAnnuity: {
        ac.min = 0.025 * existingAc.balance;
        ac.max = 0.275 * existingAc.balance;
        break;
      }
      case InvestmentAccountType.Discretionary: {
        ac.min = 0;
        ac.max = existingAc.balance;
        break;
      }
      case InvestmentAccountType.Property: {
        break;
      }
      case InvestmentAccountType.Tfsa: {
        ac.min = 0;
        ac.max = existingAc.balance;
        break;
      }
    }
    ac.targetPercentageWeight =
      accountBalancesPreIncome[i].account.incomeWithdrawalWeight / 100;
    ac.targetIncome =
      (accountBalancesPreIncome[i].account.incomeWithdrawalWeight / 100) *
      income;
    ac.residual = ac.targetIncome;
    accountIncomes.push(ac);
  }
  // apply actual income according to weights
  var allMaxed = _.filter(accountIncomes, {}).length == accountIncomes.length;
  while (
    _.sumBy(accountIncomes, "actualIncome") !=
      _.sumBy(accountIncomes, "targetIncome") &&
    allMaxed == false
  ) {
    var residual =
      _.sumBy(accountIncomes, "targetIncome") -
      _.sumBy(accountIncomes, "actualIncome");
    for (var i = 0; i < accountIncomes.length; i++) {
      var existingAc = accountIncomes[i];
      //
      //  existingAc.actualIncome =
    }
  }
  // calculate new balances based on income
  for (var i = 0; i < accountBalancesPreIncome.length; i++) {
    var postIncome = accountBalancesPostIncome[i];
    var income_1 = accountIncomes[i];
    postIncome.balance = postIncome.balance - income_1.actualIncome;
    postIncome.balanceOptimisticValue =
      postIncome.balanceOptimisticValue - income_1.actualIncome;
    postIncome.balanceOptimisticValue2 =
      postIncome.balanceOptimisticValue2 - income_1.actualIncome;
    postIncome.balanceOptimisticValue3 =
      postIncome.balanceOptimisticValue3 - income_1.actualIncome;
    postIncome.balancePessimisticValue =
      postIncome.balancePessimisticValue - income_1.actualIncome;
    postIncome.balancePessimisticValue2 =
      postIncome.balancePessimisticValue2 - income_1.actualIncome;
    postIncome.balancePessimisticValue3 =
      postIncome.balancePessimisticValue3 - income_1.actualIncome;
    // accountBalancesPostIncome.push(postIncome);
  }
  return accountBalancesPostIncome;
}
var AccountIncomeContraints = /** @class */ (function() {
  function AccountIncomeContraints(init) {
    this.account = new InvestmentAccount();
    this.startBalance = 0;
    this.endBalance = 0;
    this.actualIncome = 0;
    this.min = 0;
    this.max = 0;
    this.targetIncome = 0;
    this.targetPercentageWeight = 0;
    this.tempProportionalWeight = 0;
    this.residual = 0;
    this.incomePercent = 0;
    Object.assign(this, init);
  }
  return AccountIncomeContraints;
})();
export { AccountIncomeContraints };
export function applyInvestmentReturns(begBalances, year) {
  var total = _.sumBy(begBalances, "accountMarketValue");
  var finalBalances = [];
  if (total != 0) {
    for (var i = 0; i < begBalances.length; i++) {
      var account = begBalances[i].account;
      var returnView = getAccountExpectedReturn(account, begBalances[i].year);
      var faccount = _.cloneDeep(begBalances[i]);
      faccount.year = year; //begBalances[i].year + 1;
      // balances
      faccount.startBalance = begBalances[i].balance;
      faccount.startBalanceOptimisticValue =
        begBalances[i].balanceOptimisticValue;
      faccount.startBalanceOptimisticValue2 =
        begBalances[i].balanceOptimisticValue2;
      faccount.startBalanceOptimisticValue3 =
        begBalances[i].balanceOptimisticValue3;
      faccount.startBalancePessimisticValue =
        begBalances[i].balancePessimisticValue;
      faccount.startBalancePessimisticValue2 =
        begBalances[i].balancePessimisticValue2;
      faccount.startBalancePessimisticValue3 =
        begBalances[i].balancePessimisticValue3;
      // calculate ending balances
      faccount.balance =
        begBalances[i].balance * (1 + returnView.expectedReturn);
      faccount.balanceOptimisticValue =
        begBalances[i].balanceOptimisticValue *
        (1 + returnView.expectedReturnOptimistic);
      faccount.balanceOptimisticValue2 =
        begBalances[i].balanceOptimisticValue2 *
        (1 + returnView.expectedReturnOptimistic2);
      faccount.balanceOptimisticValue3 =
        begBalances[i].balanceOptimisticValue3 *
        (1 + returnView.expectedReturnOptimistic3);
      faccount.balancePessimisticValue =
        begBalances[i].balancePessimisticValue *
        (1 + returnView.expectedReturnPessimistic);
      faccount.balancePessimisticValue2 =
        begBalances[i].balancePessimisticValue2 *
        (1 + returnView.expectedReturnPessimistic2);
      faccount.balancePessimisticValue3 =
        begBalances[i].balancePessimisticValue3 *
        (1 + returnView.expectedReturnPessimistic3);
      finalBalances.push(faccount);
    }
  }
  // console.log("applyInvestmentReturns -> finalBalances", finalBalances);
  return finalBalances;
}
export function getAaForAccounts(balances) {
  var total = _.sumBy(balances, "balance");
  var aa = new AssetAllocation();
  if (total != 0) {
    for (var i = 0; i < balances.length; i++) {
      var aaT = balances[i];
      //  let aa: AssetAllocation = getAccountPortfolioAssetAllocation(account);
      var accountWeight = aaT.balance / total;
      aa.localCash += accountWeight * aaT.assetAllocation.localCash;
      aa.localBonds += accountWeight * aaT.assetAllocation.localBonds;
      aa.localEquity += accountWeight * aaT.assetAllocation.localEquity;
      aa.localProperty += accountWeight * aaT.assetAllocation.localProperty;
      aa.foreignCash += accountWeight * aaT.assetAllocation.foreignCash;
      aa.foreignBonds += accountWeight * aaT.assetAllocation.foreignBonds;
      aa.foreignEquity += accountWeight * aaT.assetAllocation.foreignEquity;
      aa.foreignProperty += accountWeight * aaT.assetAllocation.foreignProperty;
      aa.commodity += accountWeight * aaT.assetAllocation.commodity;
      aa.africa += accountWeight * aaT.assetAllocation.africa;
    }
  }
  return aa;
}
export function applyAaToAccounts(balances) {
  var total = _.sumBy(balances, "accountMarketValue");
  var finalBalances = [];
  if (total != 0) {
    for (var i = 0; i < balances.length; i++) {
      var account = balances[i].account;
      var aa = getAccountPortfolioAssetAllocation(account);
      var faccount = _.cloneDeep(balances[i]);
      faccount.assetAllocation = aa;
      finalBalances.push(faccount);
    }
  }
  return finalBalances;
}
export function applyTicToAccounts(balances) {
  var total = _.sumBy(balances, "accountMarketValue");
  var finalBalances = [];
  if (total != 0) {
    for (var i = 0; i < balances.length; i++) {
      var account = balances[i].account;
      var tic = getAccountTic(account);
      var faccount = _.cloneDeep(balances[i]);
      faccount.tic = tic;
      finalBalances.push(faccount);
    }
  }
  return finalBalances;
}
export function getExpectedReturn(accounts) {
  var total = _.sumBy(accounts, "accountMarketValue");
  var weightedExpectedReturn = 0;
  if (total != 0) {
    for (var i = 0; i < accounts.length; i++) {
      var account = accounts[i];
      var accountWeight = account.accountMarketValue / total;
      for (var p = 0; p < account.portfolios.length; p++) {
        var portfolioWeight = account.portfolios[p];
        var portfolio = portfolioWeight.portfolio;
        var effectiveWeight = (portfolioWeight.weight / 100) * accountWeight;
        weightedExpectedReturn += effectiveWeight * portfolio.expectedReturn;
      }
    }
  }
  return weightedExpectedReturn;
}
export function getAccountTic(account) {
  var total = account.accountMarketValue;
  var targetTic = 0;
  if (total != 0) {
    for (var p = 0; p < account.portfolios.length; p++) {
      var portfolioWeight = account.portfolios[p];
      var portfolio = portfolioWeight.portfolio;
      var effectiveWeight = portfolioWeight.weight / 100;
      targetTic += effectiveWeight * portfolio.targetTic;
    }
  }
  return targetTic;
}
export function getAccountExpectedReturn(account, year) {
  var total = account.accountMarketValue;
  var localCash = 0;
  var localBonds = 0;
  var localEquity = 0;
  var localProperty = 0;
  var foreignCash = 0;
  var foreignBonds = 0;
  var foreignEquity = 0;
  var foreignProperty = 0;
  var commodity = 0;
  var africa = 0;
  if (total != 0) {
    for (var p = 0; p < account.portfolios.length; p++) {
      var portfolioWeight = account.portfolios[p];
      var portfolio = portfolioWeight.portfolio;
      var effectiveWeight = portfolioWeight.weight / 100;
      localCash += effectiveWeight * portfolio.assetAllocation.localCash;
      localBonds += effectiveWeight * portfolio.assetAllocation.localBonds;
      localEquity += effectiveWeight * portfolio.assetAllocation.localEquity;
      localProperty +=
        effectiveWeight * portfolio.assetAllocation.localProperty;
      foreignCash += effectiveWeight * portfolio.assetAllocation.foreignBonds;
      foreignBonds += effectiveWeight * portfolio.assetAllocation.foreignBonds;
      foreignEquity +=
        effectiveWeight * portfolio.assetAllocation.foreignEquity;
      foreignProperty +=
        effectiveWeight * portfolio.assetAllocation.foreignProperty;
      commodity += effectiveWeight * portfolio.assetAllocation.commodity;
      africa += effectiveWeight * portfolio.assetAllocation.africa;
    }
  }
  var calculatePortfolioStatsResponse = calculatePortfolioStats(
    new CalculateStatsRequest({
      assetAllocation: new AssetAllocation({
        localCash: localCash,
        localBonds: localBonds,
        localEquity: localEquity,
        localProperty: localProperty,
        foreignCash: foreignCash,
        foreignBonds: foreignBonds,
        foreignEquity: foreignEquity,
        foreignProperty: foreignProperty,
        commodity: commodity,
        africa: africa,
      }),
    })
  );
  // time adjusted return = z-score * st dev / (t)^0.5
  var timeAdjustedReturn1 =
    (1.6449 * calculatePortfolioStatsResponse.standardDeviation) /
    Math.pow(year, 0.5); // 90th percentile
  var timeAdjustedReturn2 =
    (0.674 * calculatePortfolioStatsResponse.standardDeviation) /
    Math.pow(year, 0.5); // 75th percentile
  var timeAdjustedReturn3 =
    (0.8416 * calculatePortfolioStatsResponse.standardDeviation) /
    Math.pow(year, 0.5); // 60th percentile
  return new ReturnView({
    expectedReturn: calculatePortfolioStatsResponse.expectedReturn,
    expectedReturnOptimistic:
      calculatePortfolioStatsResponse.expectedReturn + timeAdjustedReturn1,
    expectedReturnOptimistic2:
      calculatePortfolioStatsResponse.expectedReturn + timeAdjustedReturn2,
    expectedReturnOptimistic3:
      calculatePortfolioStatsResponse.expectedReturn + timeAdjustedReturn3,
    expectedReturnPessimistic:
      calculatePortfolioStatsResponse.expectedReturn - timeAdjustedReturn1,
    expectedReturnPessimistic2:
      calculatePortfolioStatsResponse.expectedReturn - timeAdjustedReturn2,
    expectedReturnPessimistic3:
      calculatePortfolioStatsResponse.expectedReturn - timeAdjustedReturn3,
  });
}
export function calculatePortfolioStats(request) {
  // get asset classes -> st dev for each
  // get correlation matrix
  // calculate st dev for account.
  // SA Cash	SA Bonds	SA Listed Property	SA Equity	Global Cash	Global Bonds	Global Property	Global Equity
  //     6.00 % 7.00 % 9.15 % 11.25 % 6.80 % 8.00 % 9.80 % 12.20 %
  //   1.04 % 8.26 % 16.03 % 18.23 % 15.10 % 14.09 % 16.68 % 16.56 %
  var expectedInflation = request.expectedInflation;
  var cashReturn = 0.01 + expectedInflation;
  var bondsReturn = 0.02 + expectedInflation;
  var propertyReturn = 0.0415 + expectedInflation;
  var equityReturn = 0.0625 + expectedInflation;
  var globalCashReturn = 0.018 + expectedInflation;
  var globalBondsReturn = 0.03 + expectedInflation;
  var globalPropertyReturn = 0.048 + expectedInflation;
  var globalEquityReturn = 0.072 + expectedInflation;
  // weighted expected return
  var expectedReturn =
    (request.assetAllocation.localCash / 100) * cashReturn +
    (request.assetAllocation.localBonds / 100) * bondsReturn +
    (request.assetAllocation.localProperty / 100) * propertyReturn +
    (request.assetAllocation.localEquity / 100) * equityReturn +
    (request.assetAllocation.foreignCash / 100) * globalCashReturn +
    (request.assetAllocation.foreignBonds / 100) * globalBondsReturn +
    (request.assetAllocation.foreignProperty / 100) * globalPropertyReturn +
    (request.assetAllocation.foreignEquity / 100) * globalEquityReturn;
  //weighted volatility/standard deviation
  // weights  x Covariance Matrix x weights Transposed
  var matrix = math.matrix([
    [
      0.00010816,
      0.00009545667048,
      -0.00008629559345,
      -0.00012121771873,
      0.00007207315977,
      0.00009360073915,
      -0.000126120083,
      -0.00004292709601,
    ],
    [
      0.00009545667048,
      0.00682276,
      0.00586780334947,
      0.00381665161571,
      -0.00489260742134,
      -0.00390783479972,
      -0.00128151301833,
      -0.00259760464524,
    ],
    [
      -0.00008629559345,
      0.00586780334947,
      0.02569609,
      0.0093177451767,
      -0.00658249855098,
      -0.00536654305896,
      0.00098102656814,
      0.00028725862312,
    ],
    [
      -0.00012121771873,
      0.00381665161571,
      0.0093177451767,
      0.03323329,
      -0.00283888165125,
      -0.00236313989706,
      0.00854537861478,
      0.01313237806718,
    ],
    [
      0.00007207315977,
      -0.00489260742134,
      -0.00658249855098,
      -0.00283888165125,
      0.022801,
      0.01995806060655,
      0.01133601677098,
      0.01329744033829,
    ],
    [
      0.00009360073915,
      -0.00390783479972,
      -0.00536654305896,
      -0.00236313989706,
      0.01995806060655,
      0.01985281,
      0.01202471894153,
      0.01281761545741,
    ],
    [
      -0.000126120083,
      -0.00128151301833,
      0.00098102656814,
      0.00854537861478,
      0.01133601677098,
      0.01202471894153,
      0.02782224,
      0.01828648357282,
    ],
    [
      -0.00004292709601,
      -0.00259760464524,
      0.00028725862312,
      0.01313237806718,
      0.01329744033829,
      0.01281761545741,
      0.01828648357282,
      0.02742336,
    ],
  ]);
  var weights = math.matrix([
    request.assetAllocation.localCash / 100,
    request.assetAllocation.localBonds / 100,
    request.assetAllocation.localProperty / 100,
    request.assetAllocation.localEquity / 100,
    request.assetAllocation.foreignCash / 100,
    request.assetAllocation.foreignBonds / 100,
    request.assetAllocation.foreignProperty / 100,
    request.assetAllocation.foreignEquity / 100,
  ]);
  // calculate st dev
  var wt = math.multiply(math.transpose(weights), matrix);
  var vol = math.multiply(wt, weights);
  var stDev = Math.pow(vol, 0.5);
  return new CalculateStatsResponse({
    expectedReturn: expectedReturn,
    standardDeviation: stDev,
  }); // math.multiply(weights, matrix);
}
export function calculateWeightedPortfolioAa(portfolioWeights) {
  var aa = new AssetAllocation();
  for (var i = 0; i < portfolioWeights.length; i++) {
    var p = portfolioWeights[i].portfolio;
    var weight = portfolioWeights[i].weight / 100;
    aa.localCash += weight * p.assetAllocation.localCash;
    aa.localBonds += weight * p.assetAllocation.localBonds;
    aa.localProperty += weight * p.assetAllocation.localProperty;
    aa.localEquity += weight * p.assetAllocation.localEquity;
    aa.foreignCash += weight * p.assetAllocation.foreignCash;
    aa.foreignBonds += weight * p.assetAllocation.foreignBonds;
    aa.foreignEquity += weight * p.assetAllocation.foreignEquity;
    aa.foreignProperty += weight * p.assetAllocation.foreignProperty;
    aa.africa += weight * p.assetAllocation.africa;
    aa.commodity += weight * p.assetAllocation.commodity;
  }
  return aa;
}
export function getAccountPortfolioAssetAllocation(account) {
  var total = account.accountMarketValue;
  var aa = new AssetAllocation();
  if (total != 0) {
    for (var p = 0; p < account.portfolios.length; p++) {
      var portfolioWeight = account.portfolios[p];
      var portfolio = portfolioWeight.portfolio;
      var effectiveWeight = portfolioWeight.weight / 100;
      aa.localCash += effectiveWeight * portfolio.assetAllocation.localCash;
      aa.localBonds += effectiveWeight * portfolio.assetAllocation.localBonds;
      aa.localEquity += effectiveWeight * portfolio.assetAllocation.localEquity;
      aa.localProperty +=
        effectiveWeight * portfolio.assetAllocation.localProperty;
      aa.foreignCash += effectiveWeight * portfolio.assetAllocation.foreignCash;
      aa.foreignBonds +=
        effectiveWeight * portfolio.assetAllocation.foreignBonds;
      aa.foreignEquity +=
        effectiveWeight * portfolio.assetAllocation.foreignEquity;
      aa.foreignProperty +=
        effectiveWeight * portfolio.assetAllocation.foreignProperty;
      aa.commodity += effectiveWeight * portfolio.assetAllocation.commodity;
      aa.africa += effectiveWeight * portfolio.assetAllocation.africa;
    }
  }
  return aa;
}
var ProjectedView = /** @class */ (function() {
  function ProjectedView(init) {
    this.year = 0;
    this.balance = 0;
    /*
            optimisticValue: 0,
              optimisticValue2: 0,
              optimisticValue3: 0,
              pessimisticValue: 0,
              pessimisticValue2: 0,
              pessimisticValue3: 0
        */
    this.balanceOptimisticValue = 0;
    this.balanceOptimisticValue2 = 0;
    this.balanceOptimisticValue3 = 0;
    this.balancePessimisticValue = 0;
    this.balancePessimisticValue2 = 0;
    this.balancePessimisticValue3 = 0;
    this.income = 0;
    this.incomePercent = 0;
    this.targetIncome = 0;
    this.assetAllocation = new AssetAllocation();
    this.tic = 0;
    Object.assign(this, init);
  }
  return ProjectedView;
})();
export { ProjectedView };
var AccountBalanceView = /** @class */ (function() {
  function AccountBalanceView(init) {
    this.account = new InvestmentAccount();
    this.accountId = 0;
    this.year = 0;
    this.balance = 0;
    this.balanceOptimisticValue = 0;
    this.balanceOptimisticValue2 = 0;
    this.balanceOptimisticValue3 = 0;
    this.balancePessimisticValue = 0;
    this.balancePessimisticValue2 = 0;
    this.balancePessimisticValue3 = 0;
    this.startBalance = 0;
    this.startBalanceOptimisticValue = 0;
    this.startBalanceOptimisticValue2 = 0;
    this.startBalanceOptimisticValue3 = 0;
    this.startBalancePessimisticValue = 0;
    this.startBalancePessimisticValue2 = 0;
    this.startBalancePessimisticValue3 = 0;
    this.income = 0;
    this.incomePercent = 0;
    this.targetIncome = 0;
    this.incomeComments = "";
    this.incomeMaxed = false;
    this.tic = 0;
    this.assetAllocation = new AssetAllocation();
    Object.assign(this, init);
  }
  return AccountBalanceView;
})();
export { AccountBalanceView };
